import React from 'react';
import Logo from '../assets/Logo.png';
import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <div className=''>
        <div className='flex gap-8 p-6 items-center'>
            <span className='gap-6 flex items-center'>
                <img src={Logo} alt='' className='w-32 h-10'></img>
                <span className='h-7 border-l-2 border-[#273773]'></span>
            </span>
            <div className='flex gap-8 justify-center uppercase text-sm font-medium text-[#273773]/70'>
                <Link to='/' smooth><span className='cursor-pointer'>Home</span></Link>
                <Link to='/about-us' smooth><span className='cursor-pointer'>About us</span></Link>
                <Link to='/services' smooth><span className='cursor-pointer'>our services</span></Link>
                <Link to='#contact' smooth><span className='cursor-pointer'>contact</span></Link>
            </div>
        </div>
    </div>
  )
}

export default Navbar;